import superagent from 'superagent';

const URL = '/lm/v1/po_requests';

export const create = (request_body, callback) => {
    superagent.post(URL)
        .send(request_body)
        .end((err, response) => {
            if (err) {
                callback(false);
                console.log('Request failed')
            } else {
                callback(response.status === 200);
            }
            console.log(response)
        });
};

export const get = (query, callback) => {
    superagent.get(URL)
        .query(query)
        .end((err, response) => {
            if (err) {
                callback([]);
                console.log('Request failed')
            } else {
                if (response.status === 200) {
                    callback(response.body);
                } else {
                    callback([]);
                    console.log('No data available')
                }
            }
            console.log(response);
        });
};

// Which methods may this user call on a po_requests route? Returns the methods array,
// or null when the route is not in their policy.
//
// Deliberately NOT the shared routePermissions() helper: that treats 401 as an expired
// session and calls logout(), which clears cookies and reloads. Here a 401 is the
// expected, correct answer whenever a route simply is not granted — the review route for
// any non-admin, or the whole service for a policy that was never granted it. Going
// through the shared helper would log those users out on opening the PO screen.
export const permissions = (route_path, callback) => {
    superagent.post('/lm/v1/login/p')
        .send({ service: 'po_requests', path: route_path })
        .end((err, response) => {
            if (response && response.status === 200) {
                callback(response.body);
            } else {
                callback(null);
            }
        });
};

export const canReview = (callback) => {
    permissions('review', methods => {
        callback(methods !== null && methods.some(m => m.name === 'PUT'));
    });
};

// status: 'APPROVED' | 'REJECTED'. A rejection must carry a reason; an approval
// may carry the real PO number the admin types in.
export const review = (body, callback) => {
    superagent.put(URL + '/review')
        .send(body)
        .end((err, response) => {
            if (err) {
                callback(false, err.status);
                console.log('Request failed')
            } else {
                callback(response.status === 200, response.status);
            }
            console.log(response);
        });
};

